import { useDisapprovedProducts } from '@/hooks/usePerformance';
import { summarizeDisapprovals, type DisapprovalSummary } from '@/lib/disapprovalSummary';

/**
 * Die abgelehnten Produkte eines Feeds fuer die Baustellen-Liste des
 * Feed-Checks. `null` heisst "nichts zu zeigen": entweder laedt es noch, oder
 * Google meldet nichts, ODER der Feed wird gar nicht geprueft (der Abruf deckt
 * nur die Rollout-Konten ab). Die Liste darf deshalb nie "0 abgelehnt" sagen.
 */
export function useFeedDisapprovals(feedId: string | null): DisapprovalSummary | null {
  const { data } = useDisapprovedProducts(feedId);
  if (!data || data.length === 0) return null;
  return summarizeDisapprovals(data);
}
